export const memoize = (fn, hashFn) => {
  const cache = {};
  return function (...args) {
    // @ts-expect-error this
    const address = hashFn ? hashFn.apply(this, args) : args[0];
    if (Object.prototype.hasOwnProperty.call(cache, address)) {
      return cache[address];
    }
    // @ts-expect-error this
    const result = fn.apply(this, args);
    cache[address] = result;
    return result;
  };
};